// extracted by mini-css-extract-plugin
export const root = "_404-module--root--xBPQx";
export const containerContent404 = "_404-module--containerContent404--2kfy0";